/**
 * @file Client providers: MUI theme, optional Auth0 SSO shell.
 */
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import type { ReactNode } from "react";
import { Auth0SsoProvider } from "@/auth/Auth0SsoProvider";
import { ApiLoadingOverlay } from "@/components/ApiLoadingOverlay";
import { isSsoConfigured } from "@/auth/sso-env";
import { AuthProvider } from "@/lib/auth-context";
import { appTheme } from "@/theme/mui-theme";

export function Providers({ children }: { children: ReactNode }) {
  const ssoConfigured = isSsoConfigured();

  const inner = (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <AuthProvider ssoConfigured={ssoConfigured}>
        {children}
        <ApiLoadingOverlay />
      </AuthProvider>
    </ThemeProvider>
  );

  if (!ssoConfigured) {
    return inner;
  }

  return <Auth0SsoProvider>{inner}</Auth0SsoProvider>;
}
